import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-overview-white',
  templateUrl: './icon-overview-white.component.html',
  styles: []
})
export class IconOverviewWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
